import React from "react";
import { Helmet } from "react-helmet-async";
import DefaultViewer from "./DefaultViewer";
import AiResearchViewer from "./AiResearchViewer";

const PdfjsViewer: React.FunctionComponent = () => {
  const searchParams = new URLSearchParams(location.search);
  // AIリサーチ画面から遷移してきた場合、researchKeyPdfクエリパラメータが存在する
  const researchKeyPdf = searchParams.get("researchKeyPdf");

  return (
    <>
      <Helmet>
        <title>日経バリューサーチ</title>
      </Helmet>
      {researchKeyPdf ? (
        <AiResearchViewer researchKeyPdf={researchKeyPdf} />
      ) : (
        <DefaultViewer />
      )}
    </>
  );
};

export default PdfjsViewer;
